import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '@environments/environment';
import { BookedTrip } from '@ibe/models';
import { SidebarService } from '@ibe/services/ui';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import * as fromStore from '../../../../store';
import { takeWhile } from 'rxjs/operators';
import * as BookedTripActions from '../../../../store/actions/booked-trip.actions';
import { INDRABFMDataStorageService } from '@ibe.services/bfm-data-storage.indra.service';
import { INDRACurrencyService } from '@ibe.services/currency.indra.service';
import { SPECIAL_CASE_MARKET_LANGUAGE_MAP, SESSION_VAR_KEY_LANGUAGE, SESSION_VAR_KEY_MARKET, DEFAULT_LANGUAGE, DEFAULT_MARKET } from '@ibe.config';
import { INDRAIbeAdminConfigService } from '@ibe.services/ibeadmin-config.service';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';

@Component({
	selector: 'app-voucher-or-promocode-view',
	templateUrl: './voucher-or-promocode-view.indra.component.html',
	styleUrls: ['./voucher-or-promocode-view.component.scss']
})
export class INDRAVoucherOrPromocodeViewComponent implements OnInit, OnDestroy {
	isAlive = true;
	TAP_hasErrors: any = false;
	environment = environment;

	bookedTripDiscounts: Array<any> = [];
	booked_trip;

	/**
	 * Dev Only
	 */
	vouchers = [
		{ id: 'TAP10', type: 'voucher', value: '10.00', label: 'TAP Discount 10' },
		{ id: 'TAP20', type: 'voucher', value: '20.00', label: 'TAP Discount 20' },
		{ id: 'TAP30', type: 'voucher', value: '30.00', label: 'TAP Discount 30' },
		{ id: 'PROMO10', type: 'promocode', value: '10.00', label: 'TAP Promocode 10' },
		{ id: 'PROMO20', type: 'promocode', value: '20.00', label: 'TAP Promocode 20' },
		{ id: 'PROMO30', type: 'promocode', value: '30.00', label: 'TAP Promocode 30' }
	];

	removeOfList = ['mile-go'];

    isMYB: boolean = false;
    
	discountTotal = 0;
	currency = '';

	constructor(
		protected sidebarService: SidebarService,
		protected route: ActivatedRoute,
		private store: Store<fromStore.State>,
        protected router: Router,
		private bfmStorage: INDRABFMDataStorageService,
		private currencyService: INDRACurrencyService,
		private ibeAdminConfigService: INDRAIbeAdminConfigService,
		private ibeAdminService: INDRAIbeAdminService
        
	) {


	}

	ngOnInit() {
        if (this.router.url.includes('/my-bookings/')) this.isMYB = true;
       
        this.bookedTripDiscounts = this.INDRA_populateDiscountTotal(this.bfmStorage.originalPNRDetailsResponse)
		this.booked_trip = this.bfmStorage.INDRA_getActiveBookedTrip();
		const currency = this.currencyService.INDRA_getCurrencySymbol();
		this.currency = currency && currency.name ?  currency.name : '';
	}

	ngOnDestroy() {
		this.isAlive = false;
    }
	
	INDRA_redirectToUrl(key) {
		const languageCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
								sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE).toLowerCase() : DEFAULT_LANGUAGE;
		const languageMap = SPECIAL_CASE_MARKET_LANGUAGE_MAP[languageCode] ? SPECIAL_CASE_MARKET_LANGUAGE_MAP[languageCode] : languageCode;
		const marketCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
								sessionStorage.getItem(SESSION_VAR_KEY_MARKET).toLowerCase() : DEFAULT_MARKET;
		const urlIbeAdmin = this.ibeAdminConfigService.getConfigurationValue(key);
		const urlNavigate = urlIbeAdmin.replace('${lang}', `${languageMap}`).replace('${market}', `${marketCode}`);
		return window.open(urlNavigate);
	}
	
    INDRA_populateDiscountTotal(pnrDetails){
			let discounts = [];
			if (pnrDetails && pnrDetails['discounts']) {
				this.booked_trip = this.bfmStorage.INDRA_getActiveBookedTrip();
				pnrDetails['discounts'].forEach(discount => {
					if(discount.amount){
						if(!discount.id){
							discount.id = this.INDRA_getTranslationKey('voucherPromocodeSidebar.text.' + discount.type.toLowerCase());
						}

						// if discount is percentage "discounts" will return percent in amount instead of actual value
						// lookup data.fare.promocodeVouchers to get actual amount that matches discount id/code
						if (discount.amountType == 'PERCENTAGE' && this.booked_trip.data.fare['promocodeVouchers']) {
							const promoVoucher = this.booked_trip.data.fare.promocodeVouchers.find(promo =>promo.code == discount.id);
							if (promoVoucher && discount.amount != promoVoucher.amount) {
								discount.amount = promoVoucher.amount
							}
						}

						let amount = discount.amount;
						let existing = discounts.find(data =>{
							return data.id == discount.id;
						});
						if (existing) {
							var existingIndex = discounts.findIndex(data=> data.id == existing.id);
							discounts[existingIndex] = {
								amount: discounts[existingIndex].amount + amount,
								currency: discounts[existingIndex].currency,
								id: discounts[existingIndex].id,
								paxId: discounts[existingIndex].paxId,
								type: discounts[existingIndex].type
							}
						} 
						else {
							discounts.push(discount);
						}
					}

				});
			}
			return discounts;
	}



	INDRA_getTranslationKey(key: string): string {
		return this.ibeAdminService.getTranslationValue(key);
	}
	
	// SIDEBAR INTERACTIONS

	/** Close sidebar and clear secondary route */
	private closeSidebar() {
		this.sidebarService.closeSidebar();
		this.router.navigate([{ outlets: { sidebar: null } }], { replaceUrl: true });
    }
    
	/** Handles close action intention **/
	TAP_handleClose() {
		this.closeSidebar();
	}
}
